import React, {useEffect, useState} from 'react';
import {getUserInfoRequest} from 'util/api';
import QuestionMark from 'components/menu/QuestionMark';
import {getImageUrl} from "../../util/configuration";

const placeholderImage = '/images/emptyProfile.svg';

const UniversalProfileHeader = ({userId, isMenu = false}) => {
    const [username, setUsername] = useState('');
    const [bigProfileImage, setBigProfileImage] = useState(null);

    useEffect(() => {
        if (!userId) {
            return;
        }
        getUserInfoRequest(userId).then(response => {
            setUsername(response.username);
            if (response.profileImageId) {
                setBigProfileImage(getImageUrl(response.profileImageId, 'scrollable'));
            } else {
                setBigProfileImage(placeholderImage);
            }
        });
    }, [userId]);

    return (
        <div className="large-profile-header">
            {!isMenu && (
                <div className="profile-header-question-mark">
                    <QuestionMark/>
                </div>
            )}
            <div className="absolute-centered">
                <div className="large-profile-image-container">
                    {bigProfileImage &&
                        <img
                            src={bigProfileImage}
                            alt="User profile"
                            className="large-profile-image"
                        />
                    }
                </div>
            </div>
            <div style={{height: '80px'}}/>
            <div className="large-profile-username">
                <span className="large-username">{username}</span>
            </div>
        </div>
    );
};

export default UniversalProfileHeader;